import _Member from './model';
import create from './create';

export const Member = _Member;

Member.create = create;

export default Member;



// WEBPACK FOOTER //
// ./data/GroupMembers/model/index.js